import { Box, Button, Modal, Typography } from '@mui/material';
import { useCurrentGameSelector, useSetCurrentGame } from '@redux/game';
import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { sendMultiScreenEventToTv } from 'services/helpers/multiScreen';
import { GameIdentifier } from 'shared-types/games';
import { PlayerEvent } from 'shared-types/player-event';

export const GameControlAirConsoleModal: FC = () => {
  const currentGame = useCurrentGameSelector();
  const { setCurrentGame } = useSetCurrentGame();
  const closeGame = () => {
    setCurrentGame(null);
    sendMultiScreenEventToTv(PlayerEvent.CLOSE_GAME);
  };

  return (
    <Modal
      open={!!currentGame && currentGame.identifier === GameIdentifier.AIRCONSOLE}
      onClose={closeGame}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          width: '100%',
        }}
      >
        <Typography variant='h3' textAlign={'center'}>
          {currentGame?.name} <FormattedMessage id={'game.on-tv'} />
        </Typography>

        <Button
          sx={{
            mt: 2,
            color: 'black',
            backgroundColor: 'white',
          }}
          onClick={closeGame}
        >
          <FormattedMessage id={'game.back-to-karake'} />
        </Button>
      </Box>
    </Modal>
  );
};
